import $ from 'jquery';
import 'bootstrap';
import 'popper.js';
import enableInlineVideo from 'iphone-inline-video';

$(function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const canSkipVideo = urlParams.get('video') === 'false';

  const $landingPageContainer = $('#landing-page');
  const $landingPlayButton = $('#play-button');
  const $landingVideoContainer = $('#landing-video-container');
  const $landingVideo = $landingVideoContainer.find('video');
  const $mapContainer = $('#map-container');
  const $tourContainer = $('#tour-container');

  if ($landingVideo.get(0)) {
    enableInlineVideo($landingVideo.get(0));
  }

  if (canSkipVideo) {
    $landingPageContainer.fadeOut();
    $landingVideoContainer.fadeOut();
    $('.sidebar').fadeIn(500);
    $mapContainer.addClass('show-map');
  } else {
    $landingPageContainer.fadeIn(500);
    $landingVideoContainer.fadeIn(500);
  }

  adjustSidebar();

  // OnEventListener functions
  $(window).resize(adjustSidebar);
  // window.addEventListener('orientationchange', adjustSidebar, false);

  $landingPlayButton.click(function () {
    $landingPageContainer.fadeOut();
    playVideo($landingVideo);
  });

  $landingVideo.on('ended', function (e) {
    closeVideo();
  });

  $('.btn-back').on('click', function () {
    $tourContainer.fadeOut(500);
    $tourContainer
      .find('iframe')
      .prop('src', 'e.currentTarget.dataset.virtualTour');
    $mapContainer.fadeIn(500);
    $('.sidebar').fadeIn(500);
    openSidebar();
    adjustSidebar();
  });

  $('[data-redirect-video]').on('click', function (e) {
    if (e.currentTarget.dataset.virtualTour) {
      $tourContainer
        .find('iframe')
        .prop('src', e.currentTarget.dataset.virtualTour);

      if (e.currentTarget.dataset.redirectVideo) {
        $landingVideoContainer.fadeIn(300);
        $landingVideo.prop('src', e.currentTarget.dataset.redirectVideo);
        $landingVideo.prop(
          'data-virtual-tour',
          e.currentTarget.dataset.virtualTour
        );

        playVideo($landingVideo);
      } else {
        $tourContainer.fadeIn(500);
        $('#map-container').fadeOut(500);
        $('.sidebar').fadeOut(500);
      }
    }
  });

  // Show all marker in category
  $('[data-nav-category]').on('click', function (e) {
    resetState();
    var $nav = $(e.currentTarget.dataset.navCategory);
    var subnavsId = $nav.find('li').map((_, q) => q.dataset.markerTarget);
    subnavsId.map((_, n) => {
      fadeShow($(n).find('.floating-icon'), 'block', 200);
      fadeShow($(n).find('.info'), 'block', 200);
    });
    $nav.closest('.sidebar__nav-list').addClass('active');
    $nav.collapse('toggle');
  });

  // Toggle collapse expand arrow //
  $('.collapse').on('hide.bs.collapse', function (e) {
    $(`a[data-nav-category="#${e.currentTarget.id}"]`)
      .find('.fa-chevron-up')
      .removeClass('fa-chevron-up')
      .addClass('fa-chevron-down');
  });

  $('.collapse').on('show.bs.collapse', function (e) {
    $(`a[data-nav-category="#${e.currentTarget.id}"]`)
      .find('.fa-chevron-down')
      .removeClass('fa-chevron-down')
      .addClass('fa-chevron-up');
  });
  // End Toggle collapse expand arrow //

  // Handle scroll to bottom item of subnav when category expanded
  $('.collapse').on('shown.bs.collapse', function (e) {
    var $parentList = $(e.currentTarget).closest('.sidebar__nav-list');
    var $siblings = $parentList.parent().children();
    var $firstChildren = $siblings.first();

    if ($parentList[0] != $firstChildren[0]) {
      $('.sidebar').animate(
        {
          scrollTop: $parentList.find('ul').children().last().offset().top
        },
        500
      );
    }
  });

  // Toggle open and close sidebar
  $('[data-sidebar-toggle]').on('click', function (e) {
    e.stopPropagation();
    var $sidebar = $(e.currentTarget).closest('.sidebar');
    $sidebar.toggleClass('open');
    if (!$sidebar.hasClass('open')) {
      $('.collapse').collapse('hide');
    }
    $('.nav-text').fadeToggle(250);
  });

  // When the marker is clicked
  $('[data-sidebar-target]').on('click', function (e) {
    resetState();
    var $marker = $(e.currentTarget);
    var targetId = e.currentTarget.dataset.sidebarTarget;
    var $sidebarItem = $(`[data-marker-target="${targetId}"]`);
    var $nav = $sidebarItem.parent().children();

    if (isPortrait()) {
      closeSidebar();
    } else {
      $sidebarItem.addClass('active');
      $sidebarItem.closest('.sidebar__nav-list').addClass('active');
    }

    showMarker($marker);
    showCategoryNode($nav);
  });

  // When the sidebar item is clicked
  $('[data-marker-target]').on('click', function (e) {
    e.preventDefault();
    resetState();
    var targetId = e.currentTarget.dataset.markerTarget;
    var $marker = $(`[data-sidebar-target="${targetId}"]`);
    var $sidebarItem = $(e.currentTarget);
    var $nav = $sidebarItem.parent().children();

    scrollTo($marker.attr('id'));

    if (isPortrait()) {
      closeSidebar();
    }

    $sidebarItem.closest('.sidebar__nav-list').addClass('active');
    $sidebarItem.addClass('active');

    showMarker($marker);
    showCategoryNode($nav);
  });

  $('#skip-video').on('click', function (e) {
    $landingVideo.prop('src', null);
    closeVideo();
  });

  function closeVideo() {
    $landingVideoContainer.fadeOut(500);

    if ($landingVideo.prop('data-virtual-tour')) {
      $tourContainer.fadeIn(500);
    } else {
      $landingVideoContainer.fadeOut(500);
      $mapContainer.fadeIn(500);
      $('.sidebar').fadeIn(500);
      $mapContainer.addClass('show-map');
      adjustSidebar();
    }
  }
});

function isPortrait() {
  return window.innerWidth < window.innerHeight;
}

function showCategoryNode($nav) {
  var subnavsId = $nav.map((_, q) => q.dataset.markerTarget);
  subnavsId.map((_, n) => fadeShow($(n).find('.floating-icon'), 'block', 200));
}

function resetState() {
  adjustSidebar();
  fadeHide($('.marker .floating-icon'), 'none', 30);
  fadeHide($('.marker .info'), 'none', 30);
  fadeHide($('.marker .btn-explore'), 'none', 30);

  $('[data-marker-target]').removeClass('active');
  $('[data-sidebar-target]').removeClass('active');
  $('.sidebar__nav-list').removeClass('active');
}

function playVideo($video) {
  adjustSidebar();

  if ($video.length > 0) {
    var video = $video.get(0);

    video.currentTime = 0;
    video.play();
    $('#map-container').fadeOut(500);
    $('.sidebar').fadeOut(500);
  }
}

function adjustSidebar() {
  var $map = $('#interactive-map');
  var margin = $map.offset() ? $map.offset().left : 0;

  if ($map.innerWidth() >= window.innerWidth) {
    $map.css('left', 0);
    $('.sidebar').css('margin-left', 0);
  } else {
    $map.css('left', 'unset');
    $('.sidebar').css('margin-left', margin > 0 ? margin : 0);
  }
}

function openSidebar() {
  $('.sidebar').addClass('open');
  $('.nav-text').toggle(true, 250);
}

function closeSidebar() {
  $('.sidebar').removeClass('open');
  $('.nav-text').toggle(false, 250);
}

function scrollTo(targetId) {
  var element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  } else {
    console.log(`There's no element with id ${targetId}`);
  }
}

// Optimise the fade and hide queue
function fadeHide($element, display, timer) {
  $element.css({ opacity: 1 }).animate(
    {
      opacity: 0
    },
    timer / 2
  );
  $element.fadeOut(timer);
}

function fadeShow($element, display, timer) {
  $element
    .css({ opacity: 0, display: display })
    .fadeIn(timer / 2)
    .animate(
      {
        opacity: 1
      },
      timer
    );
}

function showMarker($marker) {
  $marker.addClass('active');
  fadeShow($marker.find('.floating-icon'), 'block', 30);
  fadeShow($marker.find('.info'), 'block', 30);
  fadeShow($marker.find('.btn-explore'), 'inline-block', 30);
}
